const formatTime = time => (time < 10 ? `0${time}` : time);

export const formattedTime = secs => {
  const min = parseInt(secs / 60, 10);
  const seconds = parseInt(secs % 60, 10);

  return `${formatTime(min)}:${formatTime(seconds)}`;
};
